<template>
    <div class="page-container">
        <!-- 头部横幅 -->
        <section class="hero">
            <div class="container">
                <h1>{{ title }}</h1>
                <p>{{ subtitle }}</p>
            </div>
        </section>
        <!-- 内容页面 -->
        <section class="page-content">
            <div class="tab-container">
                <!-- Tab 导航：蓝白风格 + 三端滚动适配 -->
                <div class="tab-scroll-wrap">
                    <div class="tab-nav">
                        <div
                        class="tab-item"
                        v-for="(tab, index) in tabList"
                        :key="index"
                        :class="{ active: activeTab === index }"
                        @click="activeTab = index"
                        >
                        {{ tab.name }}
                        </div>
                    </div>
                </div>

                <!-- Tab 内容：对应展示每个 tab 的 dataList 卡片列表 -->
                <div class="tab-content">
                    <div 
                        v-show="activeTab === index" 
                        v-for="(tab, index) in tabList" 
                        :key="index"
                        class="tab-panel"
                    >
                        <!-- 卡片列表：每行一个卡片，三端自适应 -->
                        <div class="card-list">
                            <div 
                                class="card-item" 
                                v-for="(card, cardIndex) in tab.dataList" 
                                :key="cardIndex"
                            >
                                <!-- 卡片标题：居中显示，空标题隐藏多余样式 -->
                                <div class="card-title" :class="{ empty: !card.title }">
                                    {{ card.title }}
                                    <div class="card-title-industry">{{ card.desc }}</div>
                                </div>
                                
                                <!-- 3 张图片并排：等宽布局，适配三端 -->
                                <div class="card-img-group">
                                    <img
                                        v-for="(pic, picIndex) in card.picList"
                                        :key="picIndex"
                                        :src="pic"
                                        alt="Card Content Image"
                                        class="card-img"
                                        loading="lazy" 
                                    />
                                </div>
                                
                                <!-- 卡片描述：空描述自动隐藏 -->
                                <!-- <div class="card-desc" v-if="card.desc">{{ card.desc }}</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 底部返回按钮 -->
        <Back></Back>
    </div>
</template>
<script>
import Back from '../components/Back.vue';

export default {
    name: "Training",
    components: {
        Back
    },
    data() {
        return {
            title: 'Enterprise Internationalization Training',
            subtitle: 'Global Layout Empowered, International Talents Forged.',
            // 激活的 Tab 索引（默认选中第一个）
            activeTab: 0,
            // Tab 列表数据（可自定义扩展）
            tabList: [
                {
                    name: "Brand Training",
                    content: "...",
                    dataList: [
                        {
                            title: 'Invest in Latin America',
                            desc: 'Outbound Investment Lecture',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/ladingmeizhou_1.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/ladingmeizhou_2.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/ladingmeizhou_3.webp'
                            ]
                        },
                        {
                            title: 'Invest in Middle East',
                            desc: 'Outbound Investment Lecture',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/zhongdong_1.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/zhongdong_2.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/zhongdong_3.webp'
                            ]
                        },
                        {
                            title: 'Invest in South Asia',
                            desc: 'Outbound Investment Lecture',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/nanya_1.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/nanya_2.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/nanya_3.webp'
                            ]
                        },
                        {
                            title: 'Invest in Mexico',
                            desc: 'Comprehensive Outbound Services',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/moxige_1.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/moxige_2.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/moxige_3.webp'
                            ]
                        },
                        {
                            title: 'Invest in Europe',
                            desc: 'Comprehensive Outbound Services',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/ouzhou_1.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/ouzhou_2.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/ouzhou_3.png'
                            ]
                        },
                        {
                            title: 'Invest in Vietnam & Malaysia',
                            desc: 'Comprehensive Outbound Services',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/yuenanmalai_1.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/yuenanmalai_2.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/yuenanmalai_3.webp'
                            ]
                        }
                    ]
                },
                {
                    name: "International Professional Knowledge Training",
                    content: "...",
                    dataList: [
                        {
                            title: 'Deshang Legal Consulting Shenzhen Tour',
                            desc: '',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/deshang_1.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/deshang_2.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/deshang_3.jpg'
                            ]
                        },
                        {
                            title: 'Seminar on Legal Issues and Trends of European Investment Hotspots',
                            desc: '',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/bird_1.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/bird_2.webp',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/bird_3.webp'
                            ]
                        },
                        {
                            title: 'Ethiopia Business Cooperation Seminar',
                            desc: '',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/aisaierbiya_1.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/aisaierbiya_2.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/aisaierbiya_3.jpg'
                            ]
                        },
                        {
                            title: 'Thailand Investment Promotion Seminar',
                            desc: '',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/taiguo_1.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/taiguo_2.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/taiguo_3.jpg'
                            ]
                        },
                        {
                            title: 'Canada Information Technology Seminar',
                            desc: '',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/jianada_1.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/jianada_2.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/jianada_3.jpg'
                            ]
                        },
                        {
                            title: 'Madagascar Seminar',
                            desc: '',
                            picList: [
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/madajiasijia_1.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/madajiasijia_2.jpg',
                                'https://res.roadlinkglb.com/pic/os/cases/peixun/madajiasijia_3.jpg'
                            ]
                        }
                    ]
                }
            ]
        }
    }
};
</script>

<style scoped>

.card-title {
    font-size: 17px;
    color: #000000;
    font-weight: 600;
    text-align: center;
    padding-bottom: 12px;
    border-bottom: 1px solid #cecbcb;
}

.card-title-industry {
  font-size: 14px;
  color: #1890ff;
  font-weight: bold;
  text-align: center; /* 标题居中 */
}
</style>